import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { DropdownFilter, StaticDropdownFilter } from '../../faceted-search/react/DropdownFilter';
import { FacetedSearchBox } from '../../faceted-search/react/filters/FacetedSearchBox';
import { ClearFilters } from '../../faceted-search/react/ClearFilters';
import { Pills } from '../../faceted-search/react/Pills';
import {
  FilterButton,
  widgetsComponentsMap,
  widgetsComponentsMapHandler
} from '../../faceted-search/react/helper';
import Offcanvas from '../../faceted-search/react/Offcanvas';

const OffcanvasContent = (props) => {
  const {
    filters,
    filtersVisibilityMap = [],
    visibleFilters = [],
    filtersVisibilitySetter,
  } = props;

  if (!filters) {
    return null;
  }

  const widgetsComponents = widgetsComponentsMap();

  function allItems(){
    return Object.values(filters).map((filter) => {

      return widgetsComponentsMapHandler(filter, widgetsComponents)
    });
  }

  function visibleItems(){
    return visibleFilters.map(filterID => {
      const filter = Object.values(filters).find(f => f.attribute === filterID);

      return widgetsComponentsMapHandler(filter, widgetsComponents);
    })
  }

  return (
    <div className='faceted-filters-form'>
      {filtersVisibilityMap.length > 0 && filtersVisibilityMap.map(item => {
        const {id, label, options} = item;

        return (
          <StaticDropdownFilter
            label={label}
            options={options}
            filtersVisibilitySetter={filtersVisibilitySetter}
            key={id}/>
        );
      })}

      {visibleFilters?.length > 0 ? visibleItems() : allItems()}
    </div>
  );
};

function renderFilters(filters, visibleFilters) {
  return visibleFilters?.length > 0 ? renderVisibleFilters(filters, visibleFilters) : renderAllFilters(filters);
}

function renderVisibleFilters(filters, visibleFilters) {
  const map = new Map();
  Object.values(filters).forEach(item => map.set(item.attribute, item));

  return visibleFilters.map(attribute => map.get(attribute)).map(renderFilter);
}

function renderAllFilters(filters){
  return Object.values(filters).map(renderFilter);
}

function renderFilter(filter) {
  const key = `filter:${filter.attribute}`;

  return <DropdownFilter
    key={key}
    filter={filter}
    label={filter.label || filter.fieldName}
  />;
}

/**
 * Grouped table filters block.
 *
 * @param {Object} props
 * @returns {JSX.Element}
 * @constructor
 */
export default function (props) {
  const {
    containerRef,
    filtersVisibilityMap = [],
    options = {hideSearchInput: false},
    visibleTablesSetter
  } = props;

  const {hideSearchInput} = options;

  const [visibleFilters, setVisibleFilters] = useState([]);

  const filters = useSelector(state => state.app.filters);
  const normalizedFilters = {};
  if (filters && Object.keys(filters).length) {
    Object.values(filters).forEach(filter => {
      normalizedFilters[filter.attribute] = filter;
    });
  }

  return (
    <div className='faceted-filters'>
      <Offcanvas title={I18n.t('faceted_search.filters.label')}>
        <OffcanvasContent filters={normalizedFilters} filtersVisibilityMap={filtersVisibilityMap} visibleFilters={visibleFilters} visibleTablesSetter={visibleTablesSetter} filtersVisibilitySetter={setVisibleFilters}/>
      </Offcanvas>
      <div className='filters-block-wrapper'>
        <p className='filters__label p--medium fw-bold mb-0 d-flex align-items-center'>
          {I18n.t('faceted_search.filters.label_horizontal')}
        </p>
        <div className='d-flex justify-content-between mb-0 filters-block'>
          <div className='filters d-flex align-items-center'>
            {filtersVisibilityMap.length > 0 && filtersVisibilityMap.map(item => {
              const {id, label, options} = item;
              return (
                <StaticDropdownFilter
                  label={label}
                  options={options}
                  filtersVisibilitySetter={setVisibleFilters}
                  key={id}/>
              );
            })}
            {filters && Object.keys(filters).length > 0 && renderFilters(filters, visibleFilters)}
          </div>
          <div className='text-search-panel mb-0'>
            <div className='faceted-filters-form'>
              {hideSearchInput === false && <FacetedSearchBox/>}
              <FilterButton/>
            </div>
          </div>
        </div>
        <ClearFilters/>
        <div className='faceted-search-pills'>
          <Pills filters={normalizedFilters} container={containerRef}/>
        </div>
      </div>
    </div>
  );
}
